var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
import { computed } from "mobx";
export class AdminViewModel {
    constructor(container) {
        this.adminUIManager = container.adminUIManager;
        this.authManager = container.authManager;
    }
    get currentAdminPage() {
        return this.adminUIManager.currentAdminPage;
    }
    setCurrentAdminPage(adminPage) {
        this.adminUIManager.setCurrentAdminPage(adminPage);
    }
    get pageTitle() {
        return "Admin";
    }
    get adminPagesToShow() {
        return this.adminUIManager.adminPagesToShow;
    }
    get myOrgName() {
        return this.authManager.orgName;
    }
    get organizationIsLive() {
        return this.adminUIManager.organizationIsLive;
    }
    get onBack() {
        return undefined;
    }
}
__decorate([
    computed,
    __metadata("design:type", Object),
    __metadata("design:paramtypes", [])
], AdminViewModel.prototype, "currentAdminPage", null);
__decorate([
    computed,
    __metadata("design:type", Object),
    __metadata("design:paramtypes", [])
], AdminViewModel.prototype, "pageTitle", null);
__decorate([
    computed,
    __metadata("design:type", Object),
    __metadata("design:paramtypes", [])
], AdminViewModel.prototype, "adminPagesToShow", null);
__decorate([
    computed,
    __metadata("design:type", Object),
    __metadata("design:paramtypes", [])
], AdminViewModel.prototype, "myOrgName", null);
__decorate([
    computed,
    __metadata("design:type", Object),
    __metadata("design:paramtypes", [])
], AdminViewModel.prototype, "organizationIsLive", null);
__decorate([
    computed,
    __metadata("design:type", Object),
    __metadata("design:paramtypes", [])
], AdminViewModel.prototype, "onBack", null);
